import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { mobile, mobileM, tablet } from "../../responsive";
import "./styles.scss";
import "./style-searchInput.scss";

// import { Search } from "@material-ui/icons";
//CiSearch
import { CiSearch } from "react-icons/ci";

//

//
import Aos from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";

const SearchContainer = styled.div`
  //
  //
  z-index: 900;
  .searchInput {
    display: flex;
    justify-content: flex-start;
    margin-left: 30px;

    /*  */
    .fas,
    .IconSearch {
      opacity: 0.3;
      color: #272727f8;
      cursor: pointer;
    }
  }
`;

//
const WrapperProducts = styled.div`
  width: 100%;
`;
//
const GallerySearchContainer = styled.div`
  //

  // ** Glass
  background: rgba(248, 248, 248);

  /*  */
  width: 100vw;
  min-height: 100vh;
  padding: 3vh 0;

  position: absolute;
  top: 100%;

  //
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  //

  ::-webkit-scrollbar {
    display: none;
  }
  ${mobile({
    flexDirection: "column",
    backgroundColor: "rgb(248, 248, 248)",
    margin: "0 0 0 0",
    overflow: "hidden",
    overflowY: "auto",
  })}
  ${mobileM({
    flexDirection: "column",
    backgroundColor: "rgb(248, 248, 248)",
    margin: "0 0 0 0",
    overflow: "hidden",
    overflowY: "auto",
  })}
    ${tablet({
    flexDirection: "column",
    backgroundColor: "rgb(248, 248, 248)",
    margin: "0 0 0 0",
    overflow: "hidden",
    overflowY: "auto",
  })}
`;

//
const Card = styled.div`
  margin: 0 auto;
  width: 80%;
  /* background: red; */
  padding: 0.2em;
  grid-template-columns: repeat(2, 1fr);
  display: grid;
  grid-gap: 0.5em;

  //
  .links-searchBar {
    color: #6b341071;
  }
  //
  //
  ${mobile({
    padding: "1em ",
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(3, 1fr)",
  })}
  ${mobileM({
    padding: "1em ",
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(3, 1fr)",
  })}
`;
//

const P = styled.p`
  font-size: calc(8px + 1vmin);
  text-transform: lowercase;
  color: #27272773;
  font-family: "Poppins-Light";
  font-weight: 600;
`;

//
//
const CardImgBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  //
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${mobile({
    width: "90%",
  })}
`;
//
//
//

//
//
// --------- anima framer input focus

//
// ** RELATED TO the framer anim on the border
const Featureesa = {
  NEUTRAL: "NEUTRAL",
  VALID: "VALID",
  INVALID: "INVALID",
};

const colorSearch = {
  [Featureesa.NEUTRAL]: (opacity) => `rgba(244, 244, 244, ${opacity})`,
  [Featureesa.VALID]: (opacity) => `rgba(241, 241, 241, ${opacity})`,
  [Featureesa.INVALID]: (opacity) => `rgba(255, 246, 232, ${opacity})`,

  // Neutral: "gba(255, 192, 203, 0.685)", //pink
  // Valid: "rgba(172, 249, 239, 0.718)", // blue
  // Invalid: "rgba(255, 0, 43, 0.904)", //red};
};
// ----------

const SearchBar = ({ placeholder, data }) => {
  //
  //
  // ** RELATED TO the framer anim on the border
  const [validity, setValidity] = useState(Featureesa.NEUTRAL);
  const colorq = colorSearch[validity];

  //
  //
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  //
  //
  //
  const [filterData, setFilterData] = useState([]);
  const [wordEntered, setWordEntered] = useState([]);
  //
  //
  const keys = ["category", "name", "brand"];
  //
  const handleFilter = (event) => {
    event.preventDefault();
    const searchWord = event.target.value;

    setWordEntered(searchWord);
    const newFilter = data.filter((value) => {
      //a
      // return value.category.toLowerCase().includes(searchWord.toLowerCase());
      //
      // ** Key (line 191) is grabbing exactly what i want from the value, which is the argument i passed inside the map, therefore represents the data from the map.
      return keys.some((key) =>
        value[key].toLowerCase().includes(searchWord.toLowerCase())
      );
    });
    //
    //

    if (searchWord === "") {
      setFilterData([]);
    } else {
      setFilterData(newFilter);
    }
  };

  const removeItem = (e) => {
    e.preventDefault(e);
    setFilterData([]);
    setWordEntered("");
  };
  //
  return (
    <>
      <SearchContainer>
        <motion.div className="searchInput">
          <motion.input
            style={{
              border: "0",
              borderRadius: "50px",
              padding: "0 10px",
              lineHeight: "25px",
              //
            }}
            initial={false}
            animate={{
              boxShadow: `0 0 0 3px ${colorq(0.5)}, 0 0 0 4px ${colorq(0)}`,
            }}
            whileFocus={{
              boxShadow: `0 0 0 2px ${colorq(1)}, 0 0 0 50px ${colorq(0)}`,
              transition: {
                boxShadow: {
                  duration: 0.3,
                  from: `0 0 0 3px ${colorq(0.5)}, 0 0 0 4px ${colorq(1)}`,
                },
              },
            }}
            onBlur={(e) => {
              const { value } = e.currentTarget;

              if (!value) {
                setValidity(Featureesa.NEUTRAL);
              } else if (value.includes(" ")) {
                setValidity(Featureesa.INVALID);
              } else {
                setValidity(Featureesa.VALID);
              }
            }}
            //
            //
            type="text"
            placeholder={placeholder}
            onChange={handleFilter}
            value={wordEntered}
          />

          {filterData.length === 0 ? (
            <CiSearch
              style={{ fontSize: "22px", margin: "10px" }}
              className="IconSearch"
            />
          ) : (
            <i
              style={{ fontSize: "22px", margin: "10px" }}
              className="fas fa-times"
              onClick={removeItem}
            ></i>
          )}
        </motion.div>
      </SearchContainer>

      <WrapperProducts>
        {filterData.length !== 0 && (
          <GallerySearchContainer>
            {filterData.slice(0, 3).map((value) => (
              <>
                <div key={value.id}>
                  <Card onClick={removeItem}>
                    <CardImgBox>
                      <Link to={`/product/${value._id}`}>
                        <motion.img
                          data-aos="fade-right"
                          src={value.image}
                          alt={value.name}
                        />
                      </Link>
                    </CardImgBox>
                  </Card>
                </div>
              </>
            ))}
          </GallerySearchContainer>
        )}
      </WrapperProducts>
    </>
  );
};

export default SearchBar;
